import { showAuthenticationModal } from 'services/showAuthenticationModal';
import { STRIPE_PUBLISHABLE_KEY } from 'constants/global';

export const checkoutPlan = (plan: 'monthly' | 'yearly') => {
  if (!sedition.currentUser.id) {
    showAuthenticationModal('signup', {
      intent: 'stripe_checkout',
      intentId: plan,
    });
    return;
  }

  fbq('track', 'InitiateCheckout', {
    content_category: 'Art Stream',
    content_ids: [plan],
    num_items: 1,
    content_name: `Art Stream (${plan})`,
    // 17 is lifetime value of a subscriber
    // Reported by Stripe as of 2020 February
    value: 17,
    currency: 'USD',
  });

  const stripe = Stripe(STRIPE_PUBLISHABLE_KEY);

  let sessionId;
  if (plan === 'yearly') {
    sessionId = STRIPE_YEARLY_SESSION_ID;
  } else if (plan === 'monthly') {
    sessionId = STRIPE_MONTHLY_SESSION_ID;
  }

  if (!sessionId) {
    bugsnag.notify('Unable to initialize stripe session');
    return Promise.reject('Unable to initialize Stripe session');
  }

  stripe
    .redirectToCheckout({
      // Make the id field from the Checkout Session creation API response
      // available to this file, so you can provide it as parameter here
      // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      sessionId,
    })
    .then(function (result) {
      bugsnag.notify('Stripe redirectToCheckout failed', {
        metaData: { error: result },
      });
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    });
};

export const handleMonthlyCheckoutClick = () => checkoutPlan('monthly');
export const handleYearlyCheckoutClick = () => checkoutPlan('yearly');
